module.exports = __webpack_public_path__ + "img/bg-login.400b3954.jpg";